<template>
  <div class="apply-type-container">
    <header>
      <span class="title">分类</span>
      <div class="right">
        <el-button :disabled="this.multipleSelection.length == 0" @click="opendelete(3)">删  除</el-button>
        <el-button type="primary" :disabled="this.multipleSelection.length !== 1" @click="editadialog()">编 辑</el-button>
        <el-button type="primary" @click="adddialog">新 增</el-button>
      </div>
    </header>
    <div class="tab-box2">
      <div class="tab-item" :class="(type === 1) ? 'active':''" @click="handleClick(1)">业务分类</div>
      <div class="tab-item" :class="(type === 2) ? 'active':''" @click="handleClick(2)">行业分类</div>
      <div class="tab-item" :class="(type === 3) ? 'active':''" @click="handleClick(3)">角色</div>
    </div>
    <el-table ref='multipleTable' :data='tableList' row-key="id" tooltip-effect='dark' style='width: 100%' @selection-change='handleSelectionChange' class="el-table-01">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='classify_name' label='名称'>
        <template  slot-scope='scope'>
          <span v-text="languageFilter(scope.row.classify_name, 1)"></span>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="分类管理" :visible.sync="handleDialog" class="dialog-manage">
      <span class="title">名称</span>
      <div class="right">
        <el-input v-model="typeName" placeholder="请输入" size="medium" maxlength="25"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveType">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="deleteDialog" class="prompt-box">
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">删除</div>
      <!-- <div class="note">提示：移出后该应用将不再显示在精品应用中，所有用户仍可以通过应用中心安装此应用。</div> -->
      <div class="prompt" style="margin: 10px 0">您确认要删除该分类吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteDialog = false">取 消</el-button>
        <el-button type="primary" @click="delType">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
// import {appIndustry, regular} from '@/common/js/constant.js'
import mixin from '@/common/js/mixins.js'
import Sortable from 'sortablejs'

export default {
  data () {
    return {
      defaultMsg: '<b>分类</b>',
      ellipsisStyle: '-webkit-line-clamp: 5;-webkit-box-orient: vertical;',
      tableList: [],
      type: 1,
      handleDialog: false,
      deleteDialog: false,
      multipleSelection: [],
      typeId: '',
      typeName: ''
    }
  },
  mixins: [mixin],
  mounted () {
    this.rowDrop()
    this.appClassifyList()
    // this.queryFchBtnAuth(({moduleId: 10}))
  },
  methods: {
    // 行拖拽
    rowDrop () {
      // 此时找到的元素是要拖拽元素的父容器
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        //  指定父元素下可被拖拽的子元素
        draggable: '.el-table__row',
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.tableList.splice(oldIndex, 1)[0]
          _this.tableList.splice(newIndex, 0, currRow)
          console.log(123123123123, _this.tableList)
          let arr = []
          _this.tableList.map((v, i) => {
            arr.push({id: v.id, sort: i})
          })
          HTTPServer.appClassifySort(arr, 'Loading').then((res) => {
          })
        }
      })
    },
    /** 获取列表 */
    appClassifyList () {
      var jsondata = {'classifyType': this.type}
      HTTPServer.appClassifyList(jsondata, 'Loading').then((res) => {
        this.tableList = res || []
      })
    },
    /** 搜索 */
    selectChange () {
      this.appClassifyList()
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
    },
    handleClick (tab) {
      this.type = tab
      this.appClassifyList()
    },
    adddialog () {
      this.typeName = ''
      this.typeId = ''
      this.handleDialog = true
    },
    saveType () {
      if (!this.typeName) {
        this.$message.error('分类名称不能为空')
        return
      }
      var jsondata = {'classify_name': this.typeName, 'classify_type': this.type}
      if (this.typeId) jsondata.id = this.typeId
      HTTPServer.appClassifySave(jsondata, 'Loading').then((res) => {
        this.handleDialog = false
        this.appClassifyList()
      })
    },
    editadialog () {
      if (this.multipleSelection.length > 1) {
        this.$message.error('只能选择一条数据')
        return
      }
      this.typeName = this.languageFilter(this.multipleSelection[0].classify_name)
      this.typeId = this.multipleSelection[0].id
      this.handleDialog = true
    },
    opendelete () {
      this.deleteDialog = true
    },
    /** 删除 */
    delType () {
      let ids = []
      this.multipleSelection.map(v => {
        ids.push(v.id)
      })
      var jsondata = {'ids': ids.toString()}
      HTTPServer.appClassifyDel(jsondata, 'Loading').then((res) => {
        this.deleteDialog = false
        this.appClassifyList()
      })
    },
    // 语言过滤
    languageFilter (name) {
      if (JSON.stringify(name).includes('{\\"language\\"')) {
        if (typeof name === 'string') {
          return JSON.parse(name).language.zh
        } else {
          return name.language.zh
        }
      } else {
        return name
      }
    }
  }
}
</script>

<style lang="scss">
.apply-type-container{
  header{
    height: auto!important;
    .right{
      >span{
        margin: 0 12px;
      }
    }
  }
  .el-table{
    height: calc(100% - 101px);
  }
  .dialog-manage{
    .el-dialog{
      width: 500px;
    }
    .el-dialog__header{
      padding: 13px 20px;
      box-shadow: inset 0 -1px 0 0 #E5E5E5;
    }
    .el-dialog__headerbtn{
      top: 14px;
      .el-dialog__close{
        font-size: 24px;
      }
    }
    .el-dialog__body{
      padding: 30px 20px 28px;
      min-height: 120px;
      .title{
        float: left;
        width: 80px;
        text-align: right;
        padding-right: 14px;
        line-height: 36px;
        font-size: 14px;
        color: #666;
      }
      .right{
        width: calc(100% - 100px);
        display: inline-block;
      }
      .note{
        font-size: 12px;
        color: #FF1717;
        margin-top: 10px;
      }
    }
    .el-dialog__footer{
      padding: 10px 20px;
      box-shadow: inset 0 1px 0 0 #E5E5E5;
      .el-button{
        padding: 8px 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/application/apply-type.vue